module.exports = __webpack_public_path__ + "static/media/leftArrow.d6a0016b.svg";